<ul class="checkbox-files">
  <li *ngFor="let file of files" [ngClass]="{'disabled': disabled && !existsFile(file)}">
    <div class="selector-checkbox">
      <label class="checklabel">
        <input
        type="checkbox"
        [checked]="existsFile(file)"
        (change)="toogleFile(file)"
        [disabled]="disabled && !existsFile(file)"
        />
        <span class="checkmark"></span>
      </label>
      <div class="selector-name">
        <span><strong [innerHTML]="file.name" (click)="toogleFile(file)"></strong> <em>(<span>{{humanFileSize(file.size)}}</span>)</em></span>
      </div>
    </div>
    <div class="selector-file">
      <span [innerHTML]="getFileExtension(file.name)"></span>
    </div>
  </li>
</ul>
